import React, { useState } from 'react';
import { X, Mail } from 'lucide-react';
import AdminOrderCard from './AdminOrderCard';
import CustomerEmailComposer from './crm/CustomerEmailComposer';
import CaseSupportLink from './cases/CaseSupportLink';

// Large popup wrapper that renders the full AdminOrderCard (expanded by
// default) so admins can work an order — status, notes, shipment, refund,
// downloads, audit — without leaving the customer modal. The EMAIL action
// opens the CRM composer with this order pre-selected so its VAT invoice is
// attached.
export default function OrderDetailModal({ order, userEmail, onClose }) {
  const [showEmail, setShowEmail] = useState(false);
  if (!order) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div className="bg-[#111115] border border-white/10 w-full max-w-3xl max-h-[90vh] overflow-y-auto relative">
        <div className="sticky top-0 bg-[#111115] z-10 flex items-center justify-between px-6 py-4 border-b border-white/5">
          <div className="min-w-0">
            <p className="text-primary text-[10px] font-bold tracking-widest">ORDER DETAIL</p>
            <p className="text-white text-sm font-bold truncate">{order.product_name}</p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {order.customer_email && (
              <button
                onClick={() => setShowEmail((s) => !s)}
                className={`inline-flex items-center gap-1.5 text-[10px] font-bold tracking-widest px-3 py-1.5 border transition-colors ${showEmail ? 'border-primary text-primary bg-primary/10' : 'border-white/10 text-white/50 hover:text-white hover:border-primary/50'}`}
              >
                <Mail className="w-3.5 h-3.5" /> EMAIL
              </button>
            )}
            <CaseSupportLink
              customerEmail={order.customer_email}
              customerName={order.customer_name}
              orderId={order.id}
              orderRef={order.invoice_number || order.product_name}
            />
            <button onClick={onClose} className="text-white/40 hover:text-white transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {showEmail && (
          <div className="p-6 pb-0">
            <CustomerEmailComposer
              customerEmail={order.customer_email}
              customerName={order.customer_name}
              orders={[order]}
              defaultOrderId={order.id}
              onClose={() => setShowEmail(false)}
            />
          </div>
        )}

        <div className="p-6">
          <AdminOrderCard order={order} userEmail={userEmail} defaultExpanded />
        </div>
      </div>
    </div>
  );
}